import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import AuthService from "../../../services/AuthService";
import ProfileService from "../../../services/ProfileService";

const EmailConfirmation: React.FC = () => {
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);

  const { token } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        if (!localStorage.getItem("user-token")) {
          toast.error("Você precisa estar logado para confirmar seu e-mail");
          navigate("/");
          return;
        }

        if (!token) {
          throw Error("Token não informado");
        }
        await ProfileService.emailConfirmation(token);
        await AuthService.refreshToken();
        toast.success("E-mail validado com sucesso");
        setIsEmailConfirmed(true);
      } catch (error: any) {
        toast.error(
          <>
            <h6>Link de verificação expirado</h6>
            <span>
              Verifique seu e-mail e envie um novo link de verificação
            </span>
          </>
        );
        navigate("/dashboard/profile");
      }
    };

    confirmEmail();
  }, [token, navigate]);

  if (!isEmailConfirmed) {
    return <DelendCentralizedCircularProgress />;
  }

  return <Navigate to="/dashboard/profile" replace={true} />;
};

export default EmailConfirmation;
